import Invoice from '@/models/invoice';
import UnpaidInvoice from '@/models/unpaid-invoice';
import Api from '@/services/api';

class InvoiceApi {
    getInvoice(onSuccess: (invoice: Invoice) => void) {
        return Api.callApi({ url: `/api/v1/invoice`, onSuccess });
    }
    
    getUnpaidInvoices(onSuccess: (unpaidInvoices: UnpaidInvoice[]) => void) {
        return Api.callApi({ url: `/api/v1/invoice/unpaid`, onSuccess });
    }

    getInvoiceLink(paymentLink: string, onSuccess: (link: string) => void) {
        return Api.post({ url: `/api/v1/invoice/link`, body: { Link: paymentLink }, appendAccessToken: false, onSuccess });
    }
}

export default new InvoiceApi();